import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrProgressComponent } from './pr-progress.component';
import { PrProgressCursorComponent } from './pr-progress-cursor/pr-progress-cursor.component';

@NgModule({
  declarations: [PrProgressComponent, PrProgressCursorComponent],
  imports: [CommonModule],
  exports: [PrProgressComponent, PrProgressCursorComponent],
})
export class PrProgressModule {}
